import { call, put, select, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify";

import {
  ADD_OPHOUSE_LEAD,
  CREATE_CLIENT,
  CREATE_CLIENT_ADD_LISTING,
  CREATE_CLIENT_APPOINTMENT, CREATE_CLIENT_BUYER_CLOSING, CREATE_CLIENT_BUYER_OFFER, CREATE_CLIENT_BUYER_PREF, CREATE_CLIENT_CHILD, CREATE_CLIENT_DOCUMENT,
  CREATE_CLIENT_IMPORTANT_DATE,
  CREATE_CLIENT_MESSAGE, CREATE_CLIENT_NOTE,
  CREATE_CLIENT_SELLER_CLOSING, CREATE_CLIENT_SELLER_LISTING,
  CREATE_CLIENT_SELLER_OFFER,
  CREATE_CLIENT_SELLER_OPHOUSE,
  CREATE_CLIENT_SELLER_PREFERENCE,
  CREATE_CLIENT_SELLER_SHOWING, CREATE_HOME_PREFRENCE, CREATE_NEW_CLIENT, DELETE_CLIENT_ADD_LISTING, DELETE_CLIENT_APPOINTMENT, DELETE_CLIENT_BUYER_CLOSING, DELETE_CLIENT_CHILD, DELETE_CLIENT_DEALS, DELETE_CLIENT_DOCUMENT, DELETE_CLIENT_IMPORTANT_DATE, DELETE_CLIENT_NOTE, DELETE_CLIENT_OPENHOUSE, DELETE_CLIENT_SELLER_CLOSING, DELETE_CLIENT_SELLER_LISTING, DELETE_CLIENT_SELLER_SHOWING, GET_CLIENTS, GET_CLIENTS_APPOINTMENT, GET_CLIENTS_DETAIL,
  GET_CLIENTS_DOCUMENT, GET_CLIENTS_MESSAGE,
  GET_CLIENTS_NOTE,
  GET_CLIENTS_SELLER_CLOSING,
  GET_CLIENTS_SELLER_LISTING,
  GET_CLIENTS_SELLER_SHOWING,
  GET_CLIENT_ADD_LISTING,
  GET_CLIENT_BUYER_CLOSING,
  GET_CLIENT_BUYER_OFFER,
  GET_CLIENT_CHILD,
  GET_CLIENT_DEALS,
  GET_CLIENT_ENGAGEMENT_LIST,
  GET_CLIENT_IMPORTANT_DATE,
  GET_CLIENT_RECENT_ACTIVITIES,
  GET_CLIENT_SELLER_OFFER,
  GET_CLIENT_SELLER_OPHOUSE,
  GET_CLIENT_UPCOMING_ACTIVITIES,
  GET_INCLIENTS,
  GET_INCLIENTS_DETAIL,
  UPDATE_CLIENT_ADD_LISTING,
  UPDATE_CLIENT_APPOINTMENT,
  UPDATE_CLIENT_BUYER_CLOSING,
  UPDATE_CLIENT_BUYER_OFFER,
  UPDATE_CLIENT_DOCUMENT,
  UPDATE_CLIENT_NOTE,
  UPDATE_CLIENT_OPENHOUSE,
  UPDATE_CLIENT_OPENHOUSE_FEEDBACK,
  UPDATE_CLIENT_PRIMARY_PROFILE,
  UPDATE_CLIENT_PROFILE,
  UPDATE_CLIENT_SELLER_CLOSING,
  UPDATE_CLIENT_SELLER_LISTING,
  UPDATE_CLIENT_SELLER_OFFER,
  UPDATE_CLIENT_SELLER_SHOWING,
  UPDATE_HOME_PREFRENCE
} from "./actionTypes"

import {
  deleteAddListingAPI,
  deleteClientAppointmentAPI,
  deleteClientBuyerClosingAPIApi,
  deleteClientChildAPI,
  deleteClientDealsUrl,
  deleteClientDocumentAPI,
  deleteClientImportantDateAPI,
  deleteClientNoteAPI,
  deleteClientOphouseAPI,
  deleteClientSellerClosingAPI,
  deleteClientSellerListingApi,
  deleteClientSellerShowingAPI,
  getClientAddListingUrl,
  getClientAppointment,
  getClientBuyerClosingAPIApi,
  getClientBuyerOfferAPI,
  getClientChildAPI,
  getClientDealsUrl,
  getClientDetailUrl, getClientDocumentUrl,
  getClientEngagementUrl,
  getClientImportantDateAPI,
  getClientInDetailUrl,
  getClientInListUrl,
  getClientListPagedUrl,
  getClientListUrl, getClientMessageUrl,
  normalizeLeadPagedResponse,
  getClientNoteUrl, getClientRecentActivitiesAPI, getClientSellerClosingUrl, getClientSellerListingUrl, getClientSellerOfferAPI, getClientSellerOphouseUrl, getClientSellerShowingUrl, getClientUpcompingActivitiesAPI, postClient, postClientAddListing, postClientAppointment,
  postClientBuyerClosingAPI,
  postClientBuyerOfferAPI,
  postClientBuyerPrefAPI,
  postClientChildAPI,
  postClientDocument, postClientImportantDateAPI, postClientMessage,
  postClientNote, postClientSellerClosing,
  postClientSellerListing, postClientSellerOfferAPI, postClientSellerOphouse, postClientSellerShowing, postHomePrefUrl, postNewClientAPI, postOpHouseLead, postQuestionClientSellerApi, updateAddListingAPI, updateClientAppointmentAPI, updateClientBuyerClosingAPIApi, updateClientBuyerOfferAPI, updateClientDocumnetAPI, updateClientNoteAPI, updateClientOphouseAPI, updateClientOphouseFeedbackAPI, updateClientPrimaryProfileAPI, updateClientProfileAPI, updateClientSellerListingUrl, updateClientSellerOfferAPI, updateClientSellerSellerAPI, updateClientSellerShowingAPI,
  updateHomePrefUrl
} from '../../helpers/backend_helper'

import {
  addClientAddListingFail,
  addClientAddListingSuccess,
  addClientAppointmentFail, addClientAppointmentSuccess,
  addClientBuyerClosingError,
  addClientBuyerClosingSuccess,
  addClientBuyerOfferError,
  addClientBuyerOfferSuccess,
  addClientBuyerPrefError,
  addClientBuyerPrefSuccess,
  addClientChildError,
  addClientChildSuccess,
  addClientDocumentFail, addClientFail, addClientImportantDateError, addClientImportantDateSuccess, addClientMessageFail,
  addClientMessageSuccess, addClientNoteFail,
  addClientNoteSuccess, addClientSellerListingFail,
  addClientSellerListingSuccess, addClientSellerOfferError, addClientSellerOfferSuccess, addClientSellerOphouseFail, addClientSellerOphouseSuccess, addClientSellerPrefFail, addClientSellerPrefSuccess, addClientSellerShwoingFail,
  addClientSellerShwoingSuccess, addClientSuccess, addNewClientError, addNewClientSuccess, addOpHouseLeadFail, addOpHouseLeadSuccess, ClientAddListingUpdateError, ClientAddListingUpdateSuccess, deleteClientAddListingFail, deleteClientAddListingSuccess, deleteClientAppointmentFail, deleteClientAppointmentSuccess, deleteClientBuyerClosingFail, deleteClientBuyerClosingSuccess, deleteClientChildSuccess, deleteClientDealFail, deleteClientDealSuccess, deleteClientDocumentFail, deleteClientDocumentSuccess, deleteClientImportantFail, deleteClientImportantSuccess, deleteClientNoteFail, deleteClientNoteSuccess, deleteClientopenhouseFail, deleteClientopenhouseSuccess, deleteClientSellerClosingFail, deleteClientSellerClosingSuccess, deleteClientSellerListingFail, deleteClientSellerListingSuccess, deleteClientSellerShowingFail, deleteClientSellerShowingSuccess, getClientAddListing, getClientAddListingFail, getClientAddListingSuccess, getClientAppointmentFail, getClientAppointmentSuccess, getClientBuyerClosingFail, getClientBuyerClosingSuccess, getClientBuyerOfferFail, getClientBuyerOfferSuccess, getClientChildFail, getClientChildSuccess, getClientDealsFail, getClientDealsSuccess, getClientDetailFail,
  getClientDetailSuccess, getClientDocumentFail,
  getClientDocumentSuccess, getClientEngagementListFail, getClientEngagementListSuccess, getClientImportantDateFail, getClientImportantDateSuccess, getClientListFail,
  getClientListSuccess, getClientMessageFail,
  getClientMessageSuccess, getClientNoteFail,
  getClientNoteSuccess,
  getClientRecentActivitiesFail,
  getClientRecentActivitiesSuccess,
  getClientSellerClosingFail,
  getClientSellerClosingSuccess,
  getClientSellerListingFail,
  getClientSellerListingSuccess,
  getClientSellerOfferFail,
  getClientSellerOfferSuccess,
  getClientSellerOphouseFail,
  getClientSellerOphouseSuccess,
  getClientSellerShwoingFail,
  getClientSellerShwoingSuccess,
  getClientUpcomingActivitiesFail,
  getClientUpcomingActivitiesSuccess,
  getInClientDetailFail,
  getInClientDetailSuccess,
  getINClientListFail,
  getInClientListSuccess,
  postHomePrefFail,
  updateClientAppointmentError,
  updateClientAppointmentSuccess,
  updateClientBuyerClosingError,
  updateClientBuyerClosingSuccess,
  updateClientBuyerOfferError,
  updateClientBuyerOfferSuccess,
  updateClientDocumentError,
  updateClientDocumentSuccess,
  updateClientNoteError,
  updateClientNoteSuccess,
  updateClientOpenhouseError,
  updateClientOpenhouseFeedbackError,
  updateClientProfileError,
  updateClientProfileSuccess,
  updateClientSellerClosingError,
  updateClientSellerClosingSuccess,
  updateClientSellerListing,
  updateClientSellerListingFail,
  updateClientSellerListingSuccess,
  updateClientSellerOfferError,
  updateClientSellerOfferSuccess,
  updateClientSellerShowingError,
  updateClientSellerShowingSuccess,
  updateHomePrefSuccess
} from "./actions"
import moment from "moment";


function* submitClient_old({ payload: { client, callback } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClient, client)
    yield put(addClientSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getClientListUrl, parseInt(client.agentId))
      yield put(addClientFail(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0]);
    }
  }
  catch (error) {

    yield put(addClientMessageFail(error))
  }
}

function* submitClient({ payload: { client, callback } }) {
  let toastId;
  try {
    console.log(client);
    toastId = toast.loading("Please wait...");
    const response = yield call(postClient, client);
    yield put(addClientSuccess(response));
    if (response?.success) {
      toast.update(toastId, {
        render: "Saved successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const q = yield select(s => s.Clients.clientListsQuery)
      const refreshBody = {
        agentId: parseInt(client.agentId, 10),
        pageNumber: q.pageNumber,
        pageSize: q.pageSize,
        sortBy: "createdDate",
        sortDirection: "desc",
        filterColumns: [],
        filterValues: [],
      }
      const listResponse = yield call(getClientListPagedUrl, refreshBody)
      const { items, totalCount } = normalizeLeadPagedResponse(listResponse)
      yield put(
        getClientListSuccess({
          items,
          totalCount,
          query: {
            pageNumber: refreshBody.pageNumber,
            pageSize: refreshBody.pageSize,
          },
        })
      )
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Something went wrong",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });
      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "An error occurred",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });

    yield put(addClientMessageFail(error));
    if (callback) callback(false);
  }
}


function* fetchAllClients({ payload }) {
  try {
    const {
      agentId,
      pageNumber,
      pageSize,
      sortBy,
      sortDirection,
      filterColumns,
      filterValues,
    } = payload || {}
    const explicitPagination = pageNumber != null || pageSize != null
    const body = {
      agentId: parseInt(agentId, 10),
      pageNumber: explicitPagination ? pageNumber ?? 1 : 1,
      pageSize: explicitPagination ? pageSize ?? 10 : 10,
      portal:'Broker',
      sortBy: sortBy ?? "createdDate",
      sortDirection: sortDirection ?? "desc",
      filterColumns: filterColumns ?? [],
      filterValues: filterValues ?? [],
    }
    const response = yield call(getClientListPagedUrl, body)
    const { items, totalCount } = normalizeLeadPagedResponse(response)
    yield put(
      getClientListSuccess({
        items,
        totalCount,
        query: {
          pageNumber: body.pageNumber,
          pageSize: body.pageSize,
        },
      })
    )
  } catch (error) {
    yield put(getClientListFail(error))
  }
}

function* fetchAllInClients({ agentID }) {
  try {
    const response = yield call(getClientInListUrl, agentID)
    yield put(getInClientListSuccess(response))
  } catch (error) {
    yield put(getINClientListFail(error))
  }
}

function* fetchClientDetail({ clientId }) {
  try {
    const response = yield call(getClientDetailUrl, clientId)
    yield put(getClientDetailSuccess(response))
  } catch (error) {
    yield put(getClientDetailFail(error))
  }
}


function* fetchClientInDetail({ clientId }) {
  try {
    const response = yield call(getClientInDetailUrl, clientId)
    yield put(getInClientDetailSuccess(response))
  } catch (error) {
    yield put(getInClientDetailFail(error))
  }
}

function* submitClientMessage({ payload: { message, history } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postClientMessage, {
      messageFromId: parseInt(message.messageFromId),
      messageToId: parseInt(message.messageToId),
      messageFrom: message.messageFrom,
      messageTo: message.messageTo,
      messageText: message.addMessage,
      agentId: parseInt(message.agentId),
      isActive: true

    })
    yield put(addClientMessageSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getClientMessageUrl, parseInt(message.messageToId), localStorage.getItem('userId'))
      yield put(getClientMessageSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientMessageFail(error))
  }
}

function* fetchClientMessage({ clientId }) {
  try {
    const response = yield call(getClientMessageUrl, clientId, localStorage.getItem('userId'))
    yield put(getClientMessageSuccess(response))
  } catch (error) {
    yield put(getClientMessageFail(error))
  }
}

function* submitClientDocument({ payload: { document, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postClientDocument, {
      documentFromId: parseInt(document.documentFromId),
      documentToId: parseInt(document.documentToId),
      documentTitle: document.documentTitle,
      documentFrom: document.documentFrom,
      documentTo: document.documentTo,
      documentLink: document.documentLink,
      documentContent: document.documentContent,
      documentStorageType:parseInt(document.documentStorageType),
      documentTypeId: 1,
      agentId: parseInt(document.agentId),
      isUrgent:(document.isUrgent==1) ? true : false,
      isActive: true

    })
    yield put(addClientMessageSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getClientDocumentUrl, parseInt(document.documentToId), localStorage.getItem('userId'))
      yield put(getClientDocumentSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientDocumentFail(error))
  }
}

function* fetchClientDocument({ clientId }) {
  try {
    const response = yield call(getClientDocumentUrl, clientId, localStorage.getItem('userId'))
    yield put(getClientDocumentSuccess(response))
  } catch (error) {
    yield put(getClientDocumentFail(error))
  }
}

function* submitClientAppointment({ payload: { appointment, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postClientAppointment, {
      appointmentTitle: appointment.appointmentTitle,
      contactName: appointment.contactName,
      contactPhone: appointment.contactPhone,
      contactEmail: appointment.contactEmail,
      appointmentStartDate: appointment.appointmentStartDate,
      startTime: appointment.startTime,
      endTime: appointment.endTime,
      appointmentType: parseInt(appointment.appointmentType),
      appointmentPriority: parseInt(appointment.appointmentPriority),
      appointmentLocationType:parseInt(appointment.appointmentLocationType),
      appointmentLocation:appointment.appointmentLocation,
      clientId: parseInt(appointment.clientId),
      agentId: parseInt(appointment.agentId),
      addedBy: appointment.addedBy

    })
    yield put(addClientAppointmentSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getClientAppointment, appointment.agentId, appointment.clientId)
      yield put(getClientAppointmentSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientAppointmentFail(error))
  }
}


function* fetchClientAppointment({ payload: { agentId, clientId } }) {
  try {
    const response = yield call(getClientAppointment, agentId, clientId)
    yield put(getClientAppointmentSuccess(response))
  } catch (error) {
    yield put(getClientAppointmentFail(error))
  }
}

function* submitClientNote({ payload: { note, history } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postClientNote, {
      noteTitle: note.noteTitle,
      clientId: parseInt(note.clientId),
      agentId: parseInt(note.agentId)

    })
    yield put(addClientNoteSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const response = yield call(getClientNoteUrl, note.agentId, note.clientId)
      yield put(getClientNoteSuccess(response))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientNoteFail(error))
  }
}

function* fetchClientNote({ payload: { agentId, clientId } }) {
  try {
    //
    const response = yield call(getClientNoteUrl, agentId, clientId)
    yield put(getClientNoteSuccess(response))
  } catch (error) {
    yield put(getClientNoteFail(error))
  }
}


function* submitClientSellerShwoing({ payload: { showing, callback } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postClientSellerShowing, {
      clientListingId: parseInt(showing.clientListingId),
      showingDate: moment(showing.showingDate).format('YYYY-MM-DD'),
      startTime: showing.startTime,
      endTime: showing.endTime,
      agentName: showing.agentName,
      agentOrganization: showing.agentOrganization,
      agentContact: showing.agentContact,
      agentEmail: showing.agentEmail,
      notificationMinutes: parseInt(30),
      clientId: parseInt(showing.clientId),
      agentId: parseInt(showing.agentId)

    })
    yield put(addClientSellerShwoingSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const response = yield call(getClientSellerShowingUrl, showing.clientId, localStorage.getItem('userId'))
      yield put(getClientSellerShwoingSuccess(response))
      if(callback){
          callback(true);
      }
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0] || "Some Error. Please try after some time");
      callback(false);
    }
  }
  catch (error) {

    yield put(addClientSellerShwoingFail(error))
     callback(false);
  }
}

function* fetchClientSellerShowing({ clientId }) {
  try {
    const agentId = localStorage.getItem('userId')
    const response = yield call(getClientSellerShowingUrl, clientId, agentId)
    yield put(getClientSellerShwoingSuccess(response))
  } catch (error) {
    yield put(getClientSellerShwoingFail(error))
  }
}

function* submitClientSellerClosing({ payload: { closing, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientSellerClosing, {
      clientListingId: parseInt(closing.clientListingId),
      closingDate: closing.closingDate,
      clientId: parseInt(closing.clientId),
      agentId: parseInt(closing.agentId)

    })
    yield put(addClientSellerShwoingSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");

      const response = yield call(getClientSellerClosingUrl, closing.clientId, localStorage.getItem('userId'))
      yield put(getClientSellerClosingSuccess(response))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientSellerShwoingFail(error))
  }
}

function* fetchClientSellerClosing({ clientId }) {
  try {
    const response = yield call(getClientSellerClosingUrl, clientId, localStorage.getItem('userId'))
    yield put(getClientSellerClosingSuccess(response))
  } catch (error) {
    yield put(getClientSellerClosingFail(error))
  }
}


function* submitClientSellerListing({ payload: { listing, callback } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientSellerListing, {
      mlsId: listing.mlsId,
      mlsurl: listing.mlsURL,
      listingDate: moment(listing.listingDate).format('YYYY-MM-DD'),
      engagementId: parseInt(listing.engagementId),
      listingAddress:listing.listingAddress,
      listingCity:listing.listingCity,
      salePrice: parseInt(listing.salePrice),
      commissionEarned: parseInt(listing.commissionEarned),
      listingStatusId: parseInt(listing.listingStatusId),
      isExclusive: (listing.isExclusive==1) ? true : false,
      clientId: parseInt(listing.clientId),
      agentId: parseInt(listing.agentId)

    })
    yield put(addClientSellerListingSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully");
      const listResponse = yield call(getClientSellerListingUrl, listing.clientId, localStorage.getItem('userId'))
      yield put(getClientSellerListingSuccess(listResponse))
       if (callback) {
        callback(true, response, listResponse);
      }
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0] || "Some Error. Please try after some time");
      if (callback) {
        callback(false);
      }
    }
  }
  catch (error) {

    yield put(addClientSellerListingFail(error))
    if (callback) {
        callback(false);
      }
  }
}

function* onClientListingUpdate({ payload: { listing, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateClientSellerListingUrl, listing);
    if (response?.success) {
      const res = yield call(getClientSellerListingUrl, listing.clientId, localStorage.getItem('userId'));
      yield put(getClientSellerListingSuccess(res));
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some error. Please try again.",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });

      if (callback && typeof callback === "function") {
        callback(false, response);
      }
    }

  } catch (error) {
    yield put(updateClientSellerListingFail(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });

    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}


function* onDeleteClientListing({ payload: listing }) {

  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientSellerListingApi, listing.id)
    yield put(deleteClientSellerListingSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getClientSellerListingUrl, listing.clientId, localStorage.getItem('userId'))
    yield put(getClientSellerListingSuccess(res))
  } catch (error) {
    yield put(deleteClientSellerListingFail(error))
  }
}

function* fetchClientSellerListing({ clientId }) {
  try {
    const response = yield call(getClientSellerListingUrl, clientId, localStorage.getItem('userId'))
    yield put(getClientSellerListingSuccess(response))
  } catch (error) {
    yield put(getClientSellerListingFail(error))
  }
}

function* submitClientSellerOphouse({ payload: { ophouse, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientSellerOphouse, {
      clientListingId: parseInt(ophouse.clientListingId),
      openhouseDate: moment(ophouse.openhouseDate).format('YYYY-MM-DD'),
      startTime: ophouse.startTime,
      endTime: ophouse.endTime,
      agentName: ophouse.agentName,
      agentOrganization: ophouse.agentOrganization,
      agentContact: ophouse.agentContact,
      agentEmail: ophouse.agentEmail,
      openhouseUrl: ophouse.openhouseUrl,
      clientId: parseInt(ophouse.clientId),
      agentId: parseInt(ophouse.agentId),
      brochureLink: ophouse.brochureLink,
      brochureContent: ophouse.brochureContent,
      brochureStorageType: 0,

    })
    yield put(addClientSellerOphouseSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const response = yield call(getClientSellerOphouseUrl, ophouse.clientId, localStorage.getItem('userId'))
      yield put(getClientSellerOphouseSuccess(response))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientSellerOphouseFail(error))
  }
}
function* fetchClientSellerOphouse({ clientId }) {
  try {
    const response = yield call(getClientSellerOphouseUrl, clientId, localStorage.getItem('userId'))
    yield put(getClientSellerOphouseSuccess(response))
  } catch (error) {
    yield put(getClientSellerOphouseFail(error))
  }
}

function* submitOpHouseLead({ payload: { lead, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postOpHouseLead, lead)
    yield put(addOpHouseLeadSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
    } else{
    toast.dismiss();
    if (response.validationErrors && response.validationErrors.length > 0) {
      toast.warn(response.validationErrors.join(", "));
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  }
  catch (error) {

    yield put(addOpHouseLeadFail(error))
  }
}


function* submitSellerPref({ payload: { question, history } }) {
  try {


    const questionAnswers = [{
      clientId: parseInt(question.clientId),
      questionAnswerId: 15,
      answersOption: question.sellerQuest[15],
    },{
      clientId: parseInt(question.clientId),
      questionAnswerId: 16,
      answersOption: question.sellerQuest[16],
    },{
      clientId: parseInt(question.clientId),
      questionAnswerId: 17,
      answersOption: question.sellerQuest[17],
    },{
      clientId: parseInt(question.clientId),
      questionAnswerId: 18,
      answersOption: question.sellerQuest[18],
    },{
      clientId: parseInt(question.clientId),
      questionAnswerId: 20,
      answersOption: question.sellerQuest[20],
    },{
      clientId: parseInt(question.clientId),
      questionAnswerId: 21,
      answersOption: question.sellerQuest[21],
    }
    ];
   //
    const response = yield call(postQuestionClientSellerApi, {
      questionAnswers
    })
    yield put(addClientSellerPrefSuccess(response))
    if (response.success == true) {
      toast.success("Saved successfully.");
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientSellerPrefFail('Some Error'))
  }
}


function* submitClientAddListing({ payload: { listing, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientAddListing, {
      mlsId: listing.mlsId,
      mlsurl: listing.mlsurl,
      listingStatusId: 1,
      isInterested: true,
      clientId: parseInt(listing.clientId),
      agentId: parseInt(listing.agentId),
      addedBy: "agent",
      listedPrice: parseInt(listing.listedPrice),
      listingCity: listing.listingCity,
      notes: listing.notes,
      listingDate: new Date()

    })
    yield put(addClientAddListingSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientAddListingFail(error))
  }
}

function* submitClientAddListingBulk({ payload: { listing, callback } }) {
  let toastId;
  try {

     toastId = toast.loading("Please wait...");
    const response = yield call(postClientAddListing, listing)
    yield put(addClientAddListingSuccess(response))
    if (response?.success) {
      toast.update(toastId, {
        render: "Saved successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const listResponse = yield call(getClientAddListingUrl, listing.clientId, listing.agentId)
     yield put(getClientAddListingSuccess(listResponse))
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Something went wrong",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });
      if (callback) callback(false);
    }
  }
  catch (error) {
    toast.update(toastId, {
      render: "An error occurred",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
    yield put(addClientAddListingFail(error))
     if (callback) callback(false);
  }
}

function* fetchClientAddListing({ payload: { clientId, agentId } }) {
  try {
    const response = yield call(getClientAddListingUrl, clientId, agentId)
    yield put(getClientAddListingSuccess(response))
  } catch (error) {
    yield put(getClientAddListingFail(error))
  }
}

function* onDeleteAddListing({ payload: addListing }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteAddListingAPI, addListing.id)
    toast.dismiss();
    toast.success("Deleted successfully.");
    yield put(deleteClientAddListingSuccess(response))
    const res = yield call(getClientAddListingUrl, addListing.clientId, addListing.agentId)
    yield put(getClientAddListingSuccess(res))
  } catch (error) {
    yield put(deleteClientAddListingFail(error))
  }
}

function* onUpdateAddListing_old({ payload:  addListing, callback  }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateAddListingAPI,addListing)
    yield put(ClientAddListingUpdateSuccess(response))
    const res = yield call(getClientAddListingUrl, addListing.clientId, addListing.agentId)
    yield put(getClientAddListingSuccess(res))
    toast.dismiss();
    toast.success("Updated successfully.");
  } catch (error) {
    yield put(ClientAddListingUpdateError(error))
  }
}

function* onUpdateAddListing({ payload: { addListing, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateAddListingAPI, addListing);
    yield put(ClientAddListingUpdateSuccess(response));
    if(response.success){
    const res = yield call(getClientAddListingUrl, addListing.clientId, addListing.agentId);
    yield put(getClientAddListingSuccess(res));
          toast.update(toastId, {
          render: "Updated successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
  }else{
        toast.update(toastId, {
          render: response.validationErrors?.[0] || "Something went wrong",
          type: "warning",
          isLoading: false,
          autoClose: 3000,
        });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
  }
  } catch (error) {
    yield put(ClientAddListingUpdateError(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });

    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}


function* onDeleteClientDocumet({ payload: document }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientDocumentAPI, document.id)
    yield put(deleteClientDocumentSuccess(response))

    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getClientDocumentUrl, document.documentToId, localStorage.getItem('userId'))
    yield put(getClientDocumentSuccess(res))
  } catch (error) {
    yield put(deleteClientDocumentFail(error))
  }
}

function* onDeleteClientAppointment({ payload: appointment }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientAppointmentAPI, appointment.id)
    yield put(deleteClientAppointmentSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getClientAppointment, appointment.agentId, appointment.clientId)
    yield put(getClientAppointmentSuccess(res))
  } catch (error) {
    yield put(deleteClientAppointmentFail(error))
  }
}

function* onClientAppointmentUpdate_old({ payload: appointment, callback }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateClientAppointmentAPI, appointment)
    toast.dismiss();
    toast.success("Updated successfully.");
    const res = yield call(getClientAppointment, appointment.agentId, appointment.clientId)
    yield put(getClientAppointmentSuccess(res))

  } catch (error) {
    yield put(updateClientAppointmentError(error))
  }
}

function* onClientAppointmentUpdate({ payload: { appointment, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateClientAppointmentAPI, appointment);
    if (response?.success) {
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000
      });
      const res = yield call(getClientAppointment, appointment.agentId, appointment.clientId);
      yield put(getClientAppointmentSuccess(res));
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Failed to update appointment.",
        type: "error",
        isLoading: false,
        autoClose: 3000
      });
      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000
    });
    yield put(updateClientAppointmentError(error));
    if (callback) callback(false);
  }
}


function* onClientDocumentUpdate({ payload: document }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateClientDocumnetAPI, document)
    toast.dismiss();
    toast.success("Updated successfully.");
    const res = yield call(getClientDocumentUrl, document.documentFromId, localStorage.getItem('userId'))
    yield put(getClientDocumentSuccess(res))
  } catch (error) {
    yield put(updateClientDocumentError(error))
  }
}

function* onDeleteClientNote({ payload: note }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientNoteAPI, note.id)
    yield put(deleteClientNoteSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getClientNoteUrl, note.agentId, note.clientId)
    yield put(getClientNoteSuccess(res))
  } catch (error) {
    yield put(deleteClientNoteFail(error))
  }
}

function* onClientNoteUpdate_old({ payload: note, callback }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateClientNoteAPI, note)
    yield put(updateClientNoteSuccess(response))
    if (response.success == true) {
    toast.dismiss();
    toast.success("Updated successfully.");
    const response = yield call(getClientNoteUrl, note.agentId, note.clientId)
    yield put(getClientNoteSuccess(response))
    } else {
    toast.dismiss();
    toast.warn("Some Error. Please try after some time");
   }

  } catch (error) {
    yield put(updateClientNoteError(error))
  }
}

function* onClientNoteUpdate({ payload: { note, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateClientNoteAPI, note);
    yield put(updateClientNoteSuccess(response));
    if (response.success === true) {
      const res = yield call(getClientNoteUrl, note.agentId, note.clientId);
      yield put(getClientNoteSuccess(res));
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }

    } else {
      toast.update(toastId, {
        render: "Some error. Please try after some time",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });

      if (callback && typeof callback === "function") {
        callback(false, response);
      }
    }

  } catch (error) {
    yield put(updateClientNoteError(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}

function* onDeleteClientOphouse({ payload: openhouse }) {
  //
  try {
    //toast.loading("Please wait...")
    const response = yield call(deleteClientOphouseAPI, openhouse.id)
    yield put(deleteClientopenhouseSuccess(response))
    const res = yield call(getClientSellerOphouseUrl, openhouse.clientId, localStorage.getItem('userId'))
    yield put(getClientSellerOphouseSuccess(res))
  } catch (error) {
    yield put(deleteClientopenhouseFail(error))
  }
}

function* onClientSellerShwoingUpdate({ payload: { showing, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateClientSellerShowingAPI, showing);
    if (response?.success) {
      const res = yield call(getClientSellerShowingUrl, showing.clientId, localStorage.getItem('userId'));
      yield put(getClientSellerShwoingSuccess(res));
      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some error. Please try again.",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(false, response);
      }
    }
  } catch (error) {
    yield put(updateClientSellerShowingError(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}


function* onDeleteClientSellerShwoing({ payload: showing }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientSellerShowingAPI, showing.id)
    yield put(deleteClientSellerShowingSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getClientSellerShowingUrl, showing.clientId, localStorage.getItem('userId'))
    yield put(getClientSellerShwoingSuccess(res))

  } catch (error) {
    yield put(deleteClientSellerShowingFail(error))
  }
}

function* onClientSellerClosingUpdate({ payload: closing }) {
  try {
    toast.loading("Please wait...")

    const response = yield call(updateClientSellerSellerAPI, closing)
    toast.dismiss();
    toast.success("Updated successfully.");
    const res = yield call(getClientSellerClosingUrl, closing.clientId)
    yield put(getClientSellerClosingSuccess(res))

  } catch (error) {
    yield put(updateClientSellerClosingError(error))
  }
}

function* onDeleteClientSellerClosing({ payload: closing }) {

  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientSellerClosingAPI, closing.id)
    //yield put(deleteClientSellerClosingSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
    const res = yield call(getClientSellerClosingUrl, closing.clientId, localStorage.getItem('userId'))
    yield put(getClientSellerClosingSuccess(response))

  } catch (error) {
    yield put(deleteClientSellerClosingFail(error))
  }
}

function* addBQuestion({ payload: { bquestion, history } }) {
  try {

    //
    //);

    const questionAnswers = [{
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 1,
      answersOption: bquestion.buyerQuest[1],
    }, {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 2,
      answersOption: bquestion.buyerQuest[2],
    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 3,
      answersOption: bquestion.buyerQuest[3],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 26,
      answersOption: bquestion.buyerQuest[26],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 4,
      answersOption: bquestion.buyerQuest[4],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 8,
      answersOption: bquestion.buyerQuest[8],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 9,
      answersOption: bquestion.buyerQuest[9],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 10,
      answersOption: bquestion.buyerQuest[10],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 11,
      answersOption: bquestion.buyerQuest[11],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 12,
      answersOption: bquestion.buyerQuest[12],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 13,
      answersOption: bquestion.buyerQuest[13],

    },
    {
      clientId: parseInt(bquestion.clientId),
      questionAnswerId: 14,
      answersOption: bquestion.buyerQuest[14],

    }

    ];
    ///
    const response = yield call(postClientBuyerPrefAPI, {
      questionAnswers
    })
    //
    yield put(addClientBuyerPrefSuccess(response))
    if (response.success == true) {
      toast.success("Saved successfully.");
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientBuyerPrefError('Some Error'))
  }
}

function* fetchClientUpcomingActivities({ agentId }) {
  try {
    const response = yield call(getClientUpcompingActivitiesAPI, agentId)
    yield put(getClientUpcomingActivitiesSuccess(response))
  } catch (error) {
    yield put(getClientUpcomingActivitiesFail(error))
  }
}

function* fetchClientRecentActivities({ agentId }) {
  try {
    const response = yield call(getClientRecentActivitiesAPI, agentId)
    yield put(getClientRecentActivitiesSuccess(response))
  } catch (error) {
    yield put(getClientRecentActivitiesFail(error))
  }
}

function* submitClienImportantDate({ payload: { importantdate, history, callback } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientImportantDateAPI, {
      clientId: parseInt(importantdate.clientId),
      agentId: parseInt(importantdate.agentId),
      name: importantdate.name,
      dateTitle: importantdate.dateTitle,
      dateMonth: parseInt(importantdate.dateMonth),
      dateDay: parseInt(importantdate.dateDay),


    })
    yield put(addClientImportantDateSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const response = yield call(getClientImportantDateAPI, importantdate.clientId, localStorage.getItem('userId'))
    yield put(getClientImportantDateSuccess(response))
      if (callback) callback(true)
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
      if (callback) callback(false)
    }
  }
  catch (error) {

    yield put(addClientImportantDateError(error))
    if (callback) callback(false)
  }
}

function* fetchClienImportantDate({ clientId }) {
  try {
    const response = yield call(getClientImportantDateAPI, clientId, localStorage.getItem('userId'))
    yield put(getClientImportantDateSuccess(response))
  } catch (error) {
    yield put(getClientImportantDateFail(error))
  }
}

function* submitClienChild({ payload: { child, history, callback } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientChildAPI, {
      clientId: parseInt(child.clientId),
      childName: child.childName,
      birthDay: moment(child.birthDay).format('YYYY-MM-DD'),
      cGender: 0,
      cChildIsActive:true,
      agentId:localStorage.getItem('userId')


    })
    yield put(addClientChildSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const response = yield call(getClientChildAPI, child.clientId, localStorage.getItem('userId'))
      yield put(getClientChildSuccess(response))
      if (callback) callback(true)
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
      if (callback) callback(false)
    }
  }
  catch (error) {

    yield put(addClientChildError(error))
    if (callback) callback(false)
  }
}

function* fetchClientChild({ clientId }) {
  try {
    const response = yield call(getClientChildAPI, clientId, localStorage.getItem('userId'))
    yield put(getClientChildSuccess(response))
  } catch (error) {
    yield put(getClientChildFail(error))
  }
}


function* onDeleteClientChild({ payload: child }) {
  //
  try {

    const response = yield call(deleteClientChildAPI, child.id)
    yield put(deleteClientChildSuccess(response))
    const res = yield call(getClientChildAPI, child.clientId, localStorage.getItem('userId'))
    yield put(getClientChildSuccess(res))

  } catch (error) {
    yield put(deleteClientImportantFail(error))
  }
}

function* onDeleteClienImportantDate({ payload: importantdate }) {
  //
  try {

    const response = yield call(deleteClientImportantDateAPI, importantdate.id)
    yield put(deleteClientImportantSuccess(response))
    const res = yield call(getClientImportantDateAPI, importantdate.clientId, localStorage.getItem('userId'))
    yield put(getClientImportantDateSuccess(res))

  } catch (error) {
    yield put(deleteClientImportantFail(error))
  }
}

function* onClientProfileUpdate({ payload: client }) {
  try {
    //toast.loading("Please wait...")
    const response = yield call(updateClientProfileAPI, client)
    const res = yield call(getClientDetailUrl, client.id)
    yield put(getClientDetailSuccess(res))
    //yield put(updateClientProfileSuccess(response))

  } catch (error) {
    yield put(updateClientProfileError(error))
  }
}


function* onClientProfilePrimaryUpdate({ payload: client }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateClientPrimaryProfileAPI, client)
    if (response.success == true) {
      toast.dismiss();
      toast.success("Updated successfully");
    const res = yield call(getClientDetailUrl, client.clientId)
    yield put(getClientDetailSuccess(res))
    }else{
      toast.dismiss();
      if (response.validationErrors && response.validationErrors.length > 0) {
        toast.warn(response.validationErrors.join(", "));
      } else {
        toast.warn("Some Error. Please try after some time");
      }
    }
    //yield put(updateClientProfileSuccess(response))

  } catch (error) {
    yield put(updateClientProfileError(error))
  }
}


function* onSubmitNewClient({ payload: {  client, history } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postNewClientAPI, {
      agentId: parseInt(client.agentId),
      userLogin: client.email,
      title: client.title,
      firstName: client.firstName,
      lastName: client.lastName,
      clientStatusId: 1,
      clientTypeId:parseInt(client.clientTypeId),
      isActive:true,
      howOffenClient:parseInt(client.howOffenClient),
      notes: client.notes,
      mobile: client.mobile,
      phone: client.phone,
      email: client.email,
      office: client.office,
      phoneExt:client.phoneExt
      })
    yield put(addNewClientSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addNewClientError(error))
  }
}


function* onSubmitClientBuyerCLosing({ payload: {  buyerclosing, history } }) {
  try {
    //
    toast.loading("Please wait...")
    const response = yield call(postClientBuyerClosingAPI, {
      clientId: parseInt(buyerclosing.clientId),
      agentId: parseInt(buyerclosing.agentId),
      mlsId: buyerclosing.mlsId,
      mlsurl: buyerclosing.mlsurl,
      closingDate: buyerclosing.closingDate,
      isActive: true
      })
    yield put(addClientBuyerClosingSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const agentId = localStorage.getItem('userId');
      const response = yield call(getClientBuyerClosingAPIApi, buyerclosing.clientId, agentId)
      yield put(getClientBuyerClosingSuccess(response))
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientBuyerClosingError(error))
  }
}

function* fetchClientBuyerClosing({ clientId }) {
  try {
     const agentId = localStorage.getItem('userId');
    const response = yield call(getClientBuyerClosingAPIApi, clientId, agentId)
    yield put(getClientBuyerClosingSuccess(response))
  } catch (error) {
    yield put(getClientBuyerClosingFail(error))
  }
}

function* onDeleteClientBuyerClosing({ payload: buyerClosing }) {
  //
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientBuyerClosingAPIApi, buyerClosing.id)
    yield put(deleteClientBuyerClosingSuccess(response))
    toast.dismiss();
    toast.success("Deleted successfully.");
     const agentId = localStorage.getItem('userId');
    const res = yield call(getClientBuyerClosingAPIApi, buyerClosing.clientId, agentId)
    yield put(getClientBuyerClosingSuccess(res))

  } catch (error) {
    yield put(deleteClientBuyerClosingFail(error))
  }
}

function* onClientBuyerClosing({ payload: buyerClosing }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateClientBuyerClosingAPIApi, buyerClosing)
    toast.dismiss();
    toast.success("Updated successfully.");
     const agentId = localStorage.getItem('userId');
    const res = yield call(getClientBuyerClosingAPIApi, buyerClosing.clientId, agentId)
    yield put(getClientBuyerClosingSuccess(res))


  } catch (error) {
    yield put(updateClientBuyerClosingError(error))
  }
}



function* onUpdateClientSellerOpenhouse({ payload: openhouse }) {
  try {
    //toast.loading("Please wait...")
    const response = yield call(updateClientOphouseAPI, openhouse)
    const res = yield call(getClientSellerOphouseUrl, openhouse.clientId, localStorage.getItem('userId'))
    yield put(getClientSellerOphouseSuccess(res))


  } catch (error) {
    yield put(updateClientOpenhouseError(error))
  }
}

function* fetchClienBuyerOffer({ refId }) {
  try {
    const response = yield call(getClientBuyerOfferAPI, refId)
    yield put(getClientBuyerOfferSuccess(response))
  } catch (error) {
    yield put(getClientBuyerOfferFail(error))
  }
}


function* submitClienBuyerOffer({ payload: buyerOffer  }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientBuyerOfferAPI,buyerOffer)
    yield put(addClientBuyerOfferSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
      const res = yield call(getClientAddListingUrl, buyerOffer.clientId, buyerOffer.agentId)
      yield put(getClientAddListingSuccess(res))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(addClientBuyerOfferError(error))
  }
}

function* onUpdateClientBuyerOffer_old({ payload: buyerOffer  }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(updateClientBuyerOfferAPI,buyerOffer)
    yield put(updateClientBuyerOfferSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Updated successfully.");
      const res = yield call(getClientAddListingUrl, buyerOffer.clientId, buyerOffer.agentId)
      yield put(getClientAddListingSuccess(res))
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {

    yield put(updateClientBuyerOfferError(error))
  }
}


function* onUpdateClientBuyerOffer({ payload: { buyerOffer, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateClientBuyerOfferAPI, buyerOffer);
    yield put(updateClientBuyerOfferSuccess(response));

    if (response.success === true) {
      const res = yield call(getClientAddListingUrl, buyerOffer.clientId, buyerOffer.agentId);
      yield put(getClientAddListingSuccess(res));
      toast.update(toastId, {
        render: "Updated successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || 'Some error to update',
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });

      if (callback && typeof callback === "function") {
        callback(false, response);
      }
    }
  } catch (error) {
    yield put(updateClientBuyerOfferError(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });

    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}


function* fetchClienSellerOffer({ refId }) {
  try {
    const response = yield call(getClientSellerOfferAPI, refId)
    yield put(getClientSellerOfferSuccess(response))
  } catch (error) {
    yield put(getClientSellerOfferFail(error))
  }
}

function* onUpdateClientSellerOffer({ payload: { sellerOffer, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(updateClientSellerOfferAPI, sellerOffer);
    yield put(updateClientSellerOfferSuccess(response));
    if (response?.success) {

       const listres = yield call(getClientSellerListingUrl, sellerOffer.clientId, localStorage.getItem('userId'))
       yield put(getClientSellerListingSuccess(listres))

      const res = yield call(getClientSellerShowingUrl, sellerOffer.clientId, localStorage.getItem('userId'));
      yield put(getClientSellerShwoingSuccess(res));



      toast.update(toastId, {
        render: "Updated successfully.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some Error. Please try after some time",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(false, response);
      }
    }
  } catch (error) {
    yield put(updateClientSellerOfferError(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });

    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}



function* submitClienSellerOffer({ payload: { sellerOffer, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postClientSellerOfferAPI, sellerOffer);
    yield put(addClientSellerOfferSuccess(response));
    if (response?.success) {
      const res = yield call(getClientSellerShowingUrl, sellerOffer.clientId, localStorage.getItem('userId'));
      yield put(getClientSellerShwoingSuccess(res));
      toast.update(toastId, {
        render: "Saved successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(true, response);
      }
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Some Error. Please try after some time",
        type: "warning",
        isLoading: false,
        autoClose: 3000,
      });
      if (callback && typeof callback === "function") {
        callback(false, response);
      }
    }
  } catch (error) {
    yield put(addClientSellerOfferError(error));
    toast.update(toastId, {
      render: "Something went wrong!",
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });

    if (callback && typeof callback === "function") {
      callback(false, error);
    }
  }
}


function* onUpdateClientSellerOpenhouseFeedback({ payload: openhouse }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateClientOphouseFeedbackAPI, openhouse)
    toast.dismiss();
    toast.success("Saved successfully.");
    const res = yield call(getClientSellerOphouseUrl, openhouse.clientId, localStorage.getItem('userId'))
    yield put(getClientSellerOphouseSuccess(res))
  } catch (error) {
    yield put(updateClientOpenhouseFeedbackError(error))
  }
}


function* fetchClientDeals({ payload: { clientId, agentId } }) {
  try {
    const response = yield call(getClientDealsUrl, clientId, agentId)
    yield put(getClientDealsSuccess(response))
  } catch (error) {
    yield put(getClientDealsFail(error))
  }
}


function* fetchClientEngagement({ payload: { clientId,agentId, typeId, statusId  } }) {
  try {
    const response = yield call(getClientEngagementUrl, clientId, agentId, typeId, statusId)
    yield put(getClientEngagementListSuccess(response))
  } catch (error) {
    yield put(getClientEngagementListFail(error))
  }
}

function* onDeleteClientDeal({ payload: deal }) {
  //
  try {
    //toast.loading("Please wait...")
    const response = yield call(deleteClientDealsUrl, deal.id)
    yield put(deleteClientDealSuccess(response))
    const res = yield call(getClientDealsUrl, deal.clientId, deal.agentId)
    yield put(getClientDealsSuccess(res))
  } catch (error) {
    yield put(deleteClientDealFail(error))
  }
}

function* submitHomePref({ payload: { homepref, history } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postHomePrefUrl,homepref)
    if (response.success == true) {
      toast.dismiss();
      toast.success("Saved successfully.");
    } else {
      toast.warn("Some Error. Please try after some time");
    }
  }
  catch (error) {
    yield put(postHomePrefFail(error))
  }
}

function* onUpdateHomePref({ payload: homepref }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateHomePrefUrl, homepref)
    toast.dismiss();
    toast.success("Updated successfully.");
  } catch (error) {
    yield put(updateHomePrefSuccess(error))
  }
}


function* clientSaga() {
  yield takeEvery(CREATE_HOME_PREFRENCE, submitHomePref)
  yield takeEvery(UPDATE_HOME_PREFRENCE, onUpdateHomePref)
  yield takeEvery(CREATE_CLIENT, submitClient)
  yield takeEvery(GET_CLIENTS, fetchAllClients)
  yield takeEvery(GET_INCLIENTS, fetchAllInClients)


  yield takeEvery(GET_CLIENTS_DETAIL, fetchClientDetail)

  yield takeEvery(GET_INCLIENTS_DETAIL, fetchClientInDetail)
  yield takeEvery(UPDATE_CLIENT_PROFILE, onClientProfileUpdate)
  yield takeEvery(UPDATE_CLIENT_PRIMARY_PROFILE, onClientProfilePrimaryUpdate)

  yield takeEvery(CREATE_CLIENT_MESSAGE, submitClientMessage)
  yield takeEvery(GET_CLIENTS_MESSAGE, fetchClientMessage)

  yield takeEvery(CREATE_CLIENT_DOCUMENT, submitClientDocument)
  yield takeEvery(GET_CLIENTS_DOCUMENT, fetchClientDocument)
  yield takeEvery(DELETE_CLIENT_DOCUMENT, onDeleteClientDocumet)
  yield takeEvery(UPDATE_CLIENT_DOCUMENT, onClientDocumentUpdate)

  yield takeEvery(CREATE_CLIENT_APPOINTMENT, submitClientAppointment)
  yield takeEvery(GET_CLIENTS_APPOINTMENT, fetchClientAppointment)
  yield takeEvery(DELETE_CLIENT_APPOINTMENT, onDeleteClientAppointment)
  yield takeEvery(UPDATE_CLIENT_APPOINTMENT, onClientAppointmentUpdate)

  yield takeEvery(CREATE_CLIENT_NOTE, submitClientNote)
  yield takeEvery(GET_CLIENTS_NOTE, fetchClientNote)
  yield takeEvery(DELETE_CLIENT_NOTE, onDeleteClientNote)
  yield takeEvery(UPDATE_CLIENT_NOTE, onClientNoteUpdate)


  yield takeEvery(CREATE_CLIENT_SELLER_LISTING, submitClientSellerListing)
  yield takeEvery(GET_CLIENTS_SELLER_LISTING, fetchClientSellerListing)
  yield takeEvery(UPDATE_CLIENT_SELLER_LISTING, onClientListingUpdate)
  yield takeEvery(DELETE_CLIENT_SELLER_LISTING, onDeleteClientListing)

  yield takeEvery(CREATE_CLIENT_SELLER_SHOWING, submitClientSellerShwoing)
  yield takeEvery(GET_CLIENTS_SELLER_SHOWING, fetchClientSellerShowing)
  yield takeEvery(UPDATE_CLIENT_SELLER_SHOWING, onClientSellerShwoingUpdate)
  yield takeEvery(DELETE_CLIENT_SELLER_SHOWING, onDeleteClientSellerShwoing)

  yield takeEvery(CREATE_CLIENT_SELLER_CLOSING, submitClientSellerClosing)
  yield takeEvery(GET_CLIENTS_SELLER_CLOSING,fetchClientSellerClosing)
  yield takeEvery(UPDATE_CLIENT_SELLER_CLOSING, onClientSellerClosingUpdate)
  yield takeEvery(DELETE_CLIENT_SELLER_CLOSING, onDeleteClientSellerClosing)


  yield takeEvery(CREATE_CLIENT_SELLER_OPHOUSE, submitClientSellerOphouse)
  yield takeEvery(GET_CLIENT_SELLER_OPHOUSE, fetchClientSellerOphouse)
  yield takeEvery(DELETE_CLIENT_OPENHOUSE, onDeleteClientOphouse)
  yield takeEvery(UPDATE_CLIENT_OPENHOUSE, onUpdateClientSellerOpenhouse)
  yield takeEvery(UPDATE_CLIENT_OPENHOUSE_FEEDBACK, onUpdateClientSellerOpenhouseFeedback)


  yield takeEvery(ADD_OPHOUSE_LEAD, submitOpHouseLead)


  yield takeEvery(CREATE_CLIENT_SELLER_PREFERENCE, submitSellerPref)


  yield takeEvery(CREATE_CLIENT_ADD_LISTING, submitClientAddListingBulk)
  yield takeEvery(GET_CLIENT_ADD_LISTING, fetchClientAddListing)
  yield takeEvery(DELETE_CLIENT_ADD_LISTING, onDeleteAddListing)
  yield takeEvery(UPDATE_CLIENT_ADD_LISTING, onUpdateAddListing)





  yield takeEvery(CREATE_CLIENT_BUYER_PREF, addBQuestion)
  yield takeEvery(GET_CLIENT_UPCOMING_ACTIVITIES, fetchClientUpcomingActivities)
  yield takeEvery(GET_CLIENT_RECENT_ACTIVITIES, fetchClientRecentActivities)
  yield takeEvery(CREATE_CLIENT_IMPORTANT_DATE, submitClienImportantDate)
  yield takeEvery(GET_CLIENT_IMPORTANT_DATE, fetchClienImportantDate)
  yield takeEvery(CREATE_CLIENT_CHILD, submitClienChild)
  yield takeEvery(GET_CLIENT_CHILD, fetchClientChild)
  yield takeEvery(DELETE_CLIENT_IMPORTANT_DATE, onDeleteClienImportantDate)

  yield takeEvery(CREATE_NEW_CLIENT, onSubmitNewClient)
  yield takeEvery(CREATE_CLIENT_BUYER_CLOSING, onSubmitClientBuyerCLosing)
  yield takeEvery(GET_CLIENT_BUYER_CLOSING, fetchClientBuyerClosing)
  yield takeEvery(DELETE_CLIENT_BUYER_CLOSING, onDeleteClientBuyerClosing)
  yield takeEvery(UPDATE_CLIENT_BUYER_CLOSING, onClientBuyerClosing)

  yield takeEvery(GET_CLIENT_BUYER_OFFER, fetchClienBuyerOffer)
  yield takeEvery(CREATE_CLIENT_BUYER_OFFER, submitClienBuyerOffer)
  yield takeEvery(UPDATE_CLIENT_BUYER_OFFER, onUpdateClientBuyerOffer)

  yield takeEvery(GET_CLIENT_SELLER_OFFER, fetchClienSellerOffer)
  yield takeEvery(CREATE_CLIENT_SELLER_OFFER, submitClienSellerOffer)
  yield takeEvery(UPDATE_CLIENT_SELLER_OFFER, onUpdateClientSellerOffer)

  yield takeEvery(GET_CLIENT_DEALS, fetchClientDeals)
  yield takeEvery(GET_CLIENT_ENGAGEMENT_LIST, fetchClientEngagement)
  yield takeEvery(DELETE_CLIENT_DEALS, onDeleteClientDeal)


    yield takeEvery(DELETE_CLIENT_CHILD, onDeleteClientChild)

}


export default clientSaga
